import { Plugin } from "prosemirror-state";
import { Extension } from "../../core/extension";
import { insertSuggestNodeCommand } from "../../core/suggest/suggest";
import { SlashCommandGroup, } from "../../core/types";
import { ReactPluginView } from "../../react/react-plugin-view";
import { EditorCalloutMenuPluginView } from "./components/EditorCalloutMenuPluginView/EditorCalloutMenuPluginView";
import { calloutNodes } from "./nodes";
import { CalloutType } from "./types";
export class CalloutExtension extends Extension {
    addNodes(nodes) {
        return nodes.append(calloutNodes);
    }
    addNodeViews(schema, nodeViews, portalContainer) {
        return {
            ...nodeViews,
            // TODO: we're temporarily disabling node view here due to a weird loop issue after upgrading prosemirror (?)
            // callout: ReactNodeView.create({
            //   portalContainer: portalContainer,
            //   component: EditorCallout,
            // }),
        };
    }
    addPlugins(schema, plugins, { portalContainer }) {
        return plugins.concat([
            new Plugin({
                view: ReactPluginView.create({
                    portalContainer,
                    component: EditorCalloutMenuPluginView,
                }),
            }),
        ]);
    }
    addSlashCommands(commands) {
        return [
            ...commands,
            {
                label: `Insert Callout`,
                description: `Insert a callout to make something stand out`,
                group: SlashCommandGroup.Advanced,
                icon: "is-insert-callout",
                command: insertSuggestNodeCommand({
                    type: "callout",
                    attrs: { type: CalloutType.info },
                    content: [{ type: "paragraph" }],
                }, 1),
            },
        ];
    }
}
